import { render, staticRenderFns } from "./PageMediakit.vue?vue&type=template&id=36d3cd51&"
import script from "./PageMediakit.vue?vue&type=script&lang=js&"
export * from "./PageMediakit.vue?vue&type=script&lang=js&"
import style0 from "./PageMediakit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports